import a from "./utils.js";
import p from "./helpers/bind.js";
import m from "./core/Axios.js";
import i from "./core/mergeConfig.js";
import f from "./defaults/index.js";
import l from "./helpers/formDataToJSON.js";
import c from "./cancel/CanceledError.js";
import d from "./cancel/CancelToken.js";
import u from "./cancel/isCancel.js";
import { VERSION as x } from "./env/data.js";
import C from "./helpers/toFormData.js";
import A from "./core/AxiosError.js";
import E from "./helpers/spread.js";
import O from "./helpers/isAxiosError.js";
import S from "./core/AxiosHeaders.js";
import H from "./adapters/adapters.js";
import T from "./helpers/HttpStatusCode.js";
function n(o) {
  var t = new m(o),
    e = p(m.prototype.request, t);
  return a.extend(e, m.prototype, t, {
    allOwnKeys: !0
  }), a.extend(e, t, null, {
    allOwnKeys: !0
  }), e.create = function (s) {
    return n(i(o, s));
  }, e;
}
var r = n(f);
r.Axios = m;
r.CanceledError = c;
r.CancelToken = d;
r.isCancel = u;
r.VERSION = x;
r.toFormData = C;
r.AxiosError = A;
r.Cancel = r.CanceledError;
r.all = function (t) {
  return Promise.all(t);
};
r.spread = E;
r.isAxiosError = O;
r.mergeConfig = i;
r.AxiosHeaders = S;
r.formToJSON = function (o) {
  return l(a.isHTMLForm(o) ? new FormData(o) : o);
};
r.getAdapter = H.getAdapter;
r.HttpStatusCode = T;
r.default = r;
export { r as default };
